export default "__VITE_ASSET__a01gfePo__"